import { render } from "./AnalysisBreakdown.vue?vue&type=template&id=ce2da4e2&scoped=true"
import script from "./AnalysisBreakdown.vue?vue&type=script&lang=js"
export * from "./AnalysisBreakdown.vue?vue&type=script&lang=js"

import "./AnalysisBreakdown.vue?vue&type=style&index=0&id=ce2da4e2&lang=css"
import "./AnalysisBreakdown.vue?vue&type=style&index=1&id=ce2da4e2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2da4e2"]])

export default __exports__